<template>
  <v-container class="mb-16">
    <v-card tile flat class="pa-8">
      <h1 class="c11">
        <span class="c20 text-h5">นโยบายความเป็นส่วนตัว</span>
      </h1>
      <p class="c11"><span class="c8">ฉบับวันที่ 14/10/2564</span></p>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0 start" start="1">
        <li class="c9 li-bullet-0"><span class="c13 c8">บทนำ</span></li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c1 li-bullet-0">
          <span class="c4"
            >นโยบายความเป็นส่วนตัวของเว็บไซต์นี้ (“นโยบายความเป็นส่วนตัว”)
            ใช้กับเว็บไซต์ </span
          ><span class="c4">https://marketpett.com/ </span
          ><span class="c4">(“เว็บไซต์”) เว็บไซต์ที่ดำเนินการโดย</span
          ><span class="c8">&nbsp;</span
          ><span class="c4">ทีมงาน Marketpett.com</span
          ><span class="c8">&nbsp;</span
          ><span class="c4"
            >(เรียกแยกและเรียกรวมกันว่า “Marketpett”, “มาร์เก็ตเพ็ท”, “เรา”,
            “พวกเรา”, “ทีมงาน”, “แอดมิน”, หรือ “เว็บไซต์”)
            เราให้ความสำคัญกับความเป็นส่วนตัวของผู้ใช้ และ
            เราเคารพและปฏิบัติตามและให้ความสำคัญกับกฎหมายและข้อบังคับเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้งาน</span
          ><span class="c4">เว็บไซต์ &nbsp;</span
          ><span class="c2"
            >(“คุณ”, “ผู้ใช้”) อย่างเคร่งครัด นโยบายความเป็นส่วนตัวนี้
            (“นโยบายความเป็นส่วนตัว”)
            มีจุดประสงค์เพื่ออธิบายขอบเขตของการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้
            รวมถึงวิธีต่าง ๆ ที่เราจัดการกับข้อมูลส่วนตัวที่คุณมอบให้เรา<br
          /></span>
        </li>
        <li class="c1 li-bullet-0">
          <span class="c2"
            >“ข้อมูลส่วนบุคคล” หมายถึง
            ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้
            ไม่ว่าทางตรงหรือทางอ้อมจริงหรือเท็จ<br
          /></span>
        </li>
        <li class="c1 li-bullet-0">
          <span class="c2"
            >ในการที่คุณได้เยี่ยมชมเว็บไซต์และ/หรือลงทะเบียนบัญชีกับเรา
            คุณได้ยอมรับข้อกำหนดและนโยบายที่กำหนดไว้ในนโยบายความเป็นส่วนตัวนี้
            และคุณยินยอมให้เราเก็บรวบรวม
            และใช้ข้อมูลส่วนบุคคลของคุณตามวัตถุประสงค์ที่ได้ระบุไว้ในนโยบายความเป็นส่วนตัวนี้<br /><br />หากคุณไม่ยินยอมกับนโยบายความเป็นส่วนตัวของเรา
            โปรดอย่าใช้บริการหรือเข้าถึงแพลตฟอร์ม
            <br /><br />เราขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้ทุกเมื่อภายใต้ขอบเขตของกฎหมาย<br /><br />หากมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัวของเรา
            เราจะแจ้งให้คุณทราบภายในเว็บไซต์และ/หรือผ่านทางช่องทางสื่อสารต่าง ๆ
            ของ Marketpett เช่น Facebook<br /><br />การเข้าใช้เว็บไซต์หลังการแก้ไขนั้นถือว่าคุณรับทราบและยอมรับการแก้ไขของนโยบายความเป็นส่วนตัวนี้<br
          /></span>
        </li>
        <li class="c1 li-bullet-0">
          <span class="c2"
            >นโยบายนี้ใช้บังคับร่วมกับข้อตกลงให้ความยินยอมใด ๆ
            ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของคุณโดยนโยบายนี้จะไม่ได้มีผลบังคับเหนือกว่าการบอกกล่าว
            หรือข้อสัญญาและข้อตกลงใด ๆ
            เว้นแต่เราจะได้กำหนดไว้โดยชัดแจ้งเป็นอย่างอื่น<br
          /></span>
        </li>
        <li class="c1 li-bullet-0">
          <span class="c2"
            >นโยบายนี้ใช้สำหรับผู้ใช้ทั้งผู้ซื้อ, ผู้ขายที่ใช้บริการของเรา
            เว้นแต่จะได้กำหนดไว้โดยชัดแจ้งเป็นอย่างอื่น</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="2">
        <li class="c9 li-bullet-0">
          <span class="c8 c15"
            >เราจะเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้เมื่อใด</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c5 li-bullet-0">
          <span class="c2">เราจะ/อาจเก็บรวบรวมข้อมูลส่วนบุคคลของคุณเมื่อ:</span>
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-2 start" start="1">
        <li class="c7 li-bullet-0">
          <span class="c2">เมื่อคุณได้เข้าถึงแพลตฟอร์มของเรา</span>
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2">เมื่อคุณใช้บริการใด ๆ ของเรา</span>
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2">เมื่อคุณลงทะเบียนสมัครบัญชีผู้ใช้กับเรา</span>
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2"
            >เมื่อคุณให้ความคิดเห็น, ข้อความ
            หรือคำร้องเรียนแก่เราผ่านทางแพลตฟอร์ม</span
          >
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2"
            >เมื่อผู้ขายขึ้นทะเบียนสินค้าเมื่อขายบนแพลตฟอร์มของเรา</span
          >
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2"
            >เมื่อคุณส่งข้อมูลส่วนบุคคลของคุณให้แก่เราด้วยเหตุผลใดก็ตาม</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="3">
        <li class="c9 li-bullet-0">
          <span class="c13 c8">เราจะเก็บรวบรวมข้อมูลส่วนบุคคลใดไว้บ้าง?</span>
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c5 li-bullet-0">
          <span class="c2">ข้อมูลส่วนบุคคลที่เราเก็บรวบรวมไว้ ได้แก่;</span>
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-2 start" start="1">
        <li class="c7 li-bullet-0">
          <span class="c2"
            >ข้อมูลทั้งหมดที่คุณส่งให้เราในการสมัครบัญชีผู้ใช้</span
          >
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2"
            >ข้อมูลทั้งหมดที่คุณส่งให้เราในการลงทะเบียนร้านค้า</span
          >
        </li>
        <li class="c7 li-bullet-0">
          <span class="c2">ข้อมูลเกี่ยวกับเครือข่ายของคุณ ได้แก่;</span>
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-3 start" start="1">
        <li class="c6 li-bullet-0">
          <span class="c2"
            >ที่อยู่ IP ของอุปกรณ์ของคุณ (“Internet Protocol address”);</span
          >
        </li>
        <li class="c6 li-bullet-0">
          <span class="c2"
            >ระบบปฏิบัติการคอมพิวเตอร์/อุปกรณ์เคลื่อนที่/โทรศัพท์มือถือ;</span
          >
        </li>
        <li class="c6 li-bullet-0">
          <span class="c2"
            >เวอร์ชันและชนิดของเบราว์เซอร์ที่ใช้เข้าถึงแพลตฟอร์ม;</span
          >
        </li>
        <li class="c6 li-bullet-0">
          <span class="c2"
            >ชนิดของอุปกรณ์เคลื่อนที่/โทรศัพท์มือถือที่ใช้เข้าถึงแพลตฟอร์ม</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="4">
        <li class="c9 li-bullet-0">
          <span class="c8 c15"
            >เรามีวิธีการใช้ข้อมูลที่คุณให้แก่เราอย่างไรบ้าง</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c1 li-bullet-0">
          <span class="c2"
            >เราเก็บรวบรวม
            และใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์อย่างน้อยหนึ่งวัตถุประสงค์ดังต่อไปนี้;</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-2 start" start="1">
        <li class="c12 li-bullet-0">
          <span class="c2"
            >เพื่อการระบุตัวตน (identity) การตรวจสอบยืนยันตัวตน (verification)
            หรือการตรวจสอบ (due diligence)</span
          >
        </li>
        <li class="c12 li-bullet-0">
          <span class="c2"
            >เพื่อรักษาและควบคุมการอัปเดตแพลตฟอร์เพื่อให้บริการของเราจะเป็นไปอย่างราบรื่น</span
          >
        </li>
        <li class="c12 li-bullet-0">
          <span class="c2"
            >เพื่อจัดการหรืออำนวยความสะดวกให้แก่ผู้ใช้งาน ปฏิบัติตามคำสั่งของคุณ
          </span>
        </li>
        <li class="c12 li-bullet-0">
          <span class="c2">จัดการหรือตอบข้อซักถาม</span>
        </li>
        <li class="c12 li-bullet-0">
          <span class="c2"
            >เพื่อติดต่อหรือสื่อสารกับคุณผ่านการโทรด้วยเสียง ข้อความ
            และ/หรือข้อความแฟกซ์ อีเมล และ/หรือการส่งไปรษณีย์ หรือในรูปแบบอื่นใด
            เพื่อวัตถุประสงค์ในการบริหาร</span
          >
        </li>
        <li class="c12 li-bullet-0">
          <span class="c2"
            >เพื่อนำไปปรับปรุงการให้บริการของเรา
            และ/หรือช่วยเสริมประสบการณ์ของลูกค้า</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="5">
        <li class="c9 li-bullet-0">
          <span class="c8 c13"
            >คุ้มครองและเก็บรักษาข้อมูลส่วนบุคคลของลูกค้าอย่างไรบ้าง</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c1 li-bullet-0">
          <span class="c2"
            >ในการรักษาความปลอดภัยให้กับข้อมูลส่วนตัวของผู้ใช้เราใช้เทคโนโลยีการเข้ารหัสเซิร์ฟเวอร์
            SSL (Secure Sockets Layer)
            ในการปกป้องข้อมูลส่วนตัวของคุณไม่ให้ปรากฏแก่บุคคลที่ไม่ได้รับอนุญาต<br
          /></span>
        </li>
        <li class="c1 li-bullet-0">
          <span class="c2"
            >ในเหตุการที่ข้อมูลส่วนตัวของคุณที่อยู่อยู่ในครอบครองของเราถูกคุกคามเราอาจจะทำการแจ้งเตื่อนให้คุณทราบผ่านทางอีเมล</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="6">
        <li class="c9 li-bullet-0">
          <span class="c13 c8">การปรับปรุงหรือเปลี่ยนแปลงข้อมูลส่วนบุคคล</span>
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-1 start" start="1">
        <li class="c1 li-bullet-0">
          <span class="c2"
            >ในกรณีที่คุณต้องการเปลี่ยนแปลงหรือแก้ไขข้อมูลใด ๆ
            ของคุณที่เราได้รวบรวมไว้ คุณสามารถทำได้โดยติดต่อเรา</span
          >
        </li>
      </ol>
      <ol class="c3 lst-kix_5n0dj4k0l6vm-0" start="7">
        <li class="c9 li-bullet-0"><span class="c8 c15">ติดต่อเรา</span></li>
        <span class="c1 c2"
          >Facebook:
          <a href="https://www.facebook.com//Marketpett.official" class="link"
            >Marketpett.official</a
          ></span
        >
      </ol>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.lst-kix_5n0dj4k0l6vm-3 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-3;
}

ol.lst-kix_m8d3nk91oq7u-2.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-2 0;
}

ol.lst-kix_5n0dj4k0l6vm-2.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-2 0;
}

.lst-kix_m8d3nk91oq7u-3 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-5 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-4, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-5, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-0 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-4 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-4, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-7 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-4, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-5, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-6, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-7, decimal) ". ";
}

ol.lst-kix_5n0dj4k0l6vm-5.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-5 0;
}

.lst-kix_m8d3nk91oq7u-6 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-4, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-5, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-6, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-2 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-0 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-0 > li:before {
  font-weight: bold;
}

.lst-kix_5n0dj4k0l6vm-1 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-4 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-4;
}

ol.lst-kix_m8d3nk91oq7u-6.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-6 0;
}

.lst-kix_m8d3nk91oq7u-8 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-3, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-4, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-5, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-6, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-7, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-8, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-4 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-4;
}

ol.lst-kix_m8d3nk91oq7u-8.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-8 0;
}

ol.lst-kix_m8d3nk91oq7u-5 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-4 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-7 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-6 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-1 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-0 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-3 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-2 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-5.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-5 0;
}

.lst-kix_m8d3nk91oq7u-8 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-8;
}

ol.lst-kix_m8d3nk91oq7u-8 {
  list-style-type: none;
}

.lst-kix_m8d3nk91oq7u-5 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-5;
}

ol.lst-kix_5n0dj4k0l6vm-3.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-3 0;
}

ol.lst-kix_5n0dj4k0l6vm-6.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-6 0;
}

.lst-kix_m8d3nk91oq7u-2 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-2;
}

.lst-kix_5n0dj4k0l6vm-6 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-6;
}

.lst-kix_5n0dj4k0l6vm-0 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-0;
}

ol.lst-kix_m8d3nk91oq7u-4.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-4 0;
}

ol.lst-kix_5n0dj4k0l6vm-0.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-0 0;
}

.lst-kix_m8d3nk91oq7u-1 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-1;
}

ol.lst-kix_5n0dj4k0l6vm-8 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-4.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-4 0;
}

ol.lst-kix_5n0dj4k0l6vm-6 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-7 {
  list-style-type: none;
}

ol.lst-kix_m8d3nk91oq7u-0.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-0 0;
}

.lst-kix_5n0dj4k0l6vm-1 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-1;
}

ol.lst-kix_5n0dj4k0l6vm-4 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-5 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-2 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-3 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-0 {
  list-style-type: none;
}

ol.lst-kix_5n0dj4k0l6vm-1 {
  list-style-type: none;
}

.lst-kix_5n0dj4k0l6vm-7 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-7;
}

ol.lst-kix_m8d3nk91oq7u-3.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-3 0;
}

.lst-kix_m8d3nk91oq7u-7 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-7;
}

ol.lst-kix_5n0dj4k0l6vm-7.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-7 0;
}

.lst-kix_m8d3nk91oq7u-0 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-0;
}

ol.lst-kix_5n0dj4k0l6vm-1.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-1 0;
}

.lst-kix_5n0dj4k0l6vm-8 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-4, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-5, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-6, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-7, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-8, decimal) ". ";
}

ol.lst-kix_5n0dj4k0l6vm-8.start {
  counter-reset: lst-ctn-kix_5n0dj4k0l6vm-8 0;
}

ol.lst-kix_m8d3nk91oq7u-1.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-1 0;
}

.lst-kix_m8d3nk91oq7u-6 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-6;
}

.lst-kix_m8d3nk91oq7u-3 > li {
  counter-increment: lst-ctn-kix_m8d3nk91oq7u-3;
}

li.li-bullet-0:before {
  margin-left: -4.5pt;
  white-space: nowrap;
  display: inline-block;
  min-width: 4.5pt;
}

.lst-kix_5n0dj4k0l6vm-3 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-4 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-4, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-5 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-4, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-5, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-5 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-5;
}

.lst-kix_5n0dj4k0l6vm-8 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-8;
}

ol.lst-kix_m8d3nk91oq7u-7.start {
  counter-reset: lst-ctn-kix_m8d3nk91oq7u-7 0;
}

.lst-kix_5n0dj4k0l6vm-6 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-4, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-5, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-6, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-7 > li:before {
  content: "" counter(lst-ctn-kix_5n0dj4k0l6vm-0, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-1, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-2, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-3, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-4, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-5, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-6, decimal) "."
    counter(lst-ctn-kix_5n0dj4k0l6vm-7, decimal) ". ";
}

.lst-kix_m8d3nk91oq7u-1 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) ". ";
}

.lst-kix_5n0dj4k0l6vm-2 > li {
  counter-increment: lst-ctn-kix_5n0dj4k0l6vm-2;
}

.lst-kix_m8d3nk91oq7u-2 > li:before {
  content: "" counter(lst-ctn-kix_m8d3nk91oq7u-0, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-1, decimal) "."
    counter(lst-ctn-kix_m8d3nk91oq7u-2, decimal) ". ";
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c5 {
  margin-left: 54pt;
  padding-top: 0pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c2 {
  background-color: #ffffff;
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Kanit", "Roboto", sans-seri;
  font-style: normal;
}

.c0 {
  background-color: #ffffff;
  color: #000000;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Kanit", "Roboto", sans-seri;
  font-style: normal;
}

.c7 {
  margin-left: 81pt;
  padding-top: 0pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c9 {
  margin-left: 31.5pt;
  padding-top: 10pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c1 {
  margin-left: 54pt;
  padding-top: 0pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c12 {
  margin-left: 81pt;
  padding-top: 0pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: justify;
}

.c6 {
  margin-left: 108pt;
  padding-top: 0pt;
  padding-left: -13.5pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c18 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Kanit", "Roboto", sans-seri;
  font-style: normal;
}

.c16 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 11pt;
}

.c19 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal;
}

.c11 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.5;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c10 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 12pt;
  font-style: normal;
}

.c13 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 14pt;
  font-style: normal;
}

.c17 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.5pt;
  font-style: normal;
}

.c20 {
  color: #000000;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 23pt;
  font-style: normal;
}

.c4 {
  background-color: #ffffff;
  font-family: "Kanit", "Roboto", sans-seri;
  font-weight: 400;
}

.c8 {
  background-color: #ffffff;
  font-family: "Kanit", "Roboto", sans-seri;
  font-weight: 500;
}

.c14 {
  background-color: #ffffff;
  max-width: 468pt;
  padding: 72pt 72pt 72pt 72pt;
}

.c3 {
  padding: 0;
  margin: 0;
}

.c15 {
  font-size: 14pt;
}

.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial";
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial";
}

h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>